import { render } from "./ManageThemeFont.vue?vue&type=template&id=dd34c9ee&lang=pug"
import script from "./ManageThemeFont.vue?vue&type=script&lang=js"
export * from "./ManageThemeFont.vue?vue&type=script&lang=js"

import "./ManageThemeFont.vue?vue&type=style&index=0&id=dd34c9ee&lang=scss"

import exportComponent from "/Users/redbot/nodeApps/thinkhub-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__